import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Card,
  Divider,
  Paper,
  IconButton,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import { RequestService, imageUrl } from "services/RequestService";
import MDSnackbar from "components/MDSnackbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Edit, Trash2 } from "lucide-react";
import { Grid, Stack } from "@mui/material";
import MDTypography from "components/MDTypography";


function parseReadableDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("ar", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(date);
}

const ProjectComments = ({ projectId }) => {
  const [comments, setComments] = useState([
    // {
    //   id: 2,
    //   projectId: 1,
    //   projectName: "ras test",
    //   message: "2تعليف تجريبي",
    //   userName: "",
    //   userId: "452d9a85-5322-4463-a99d-a25fd13f7340",
    //   updatedAt: "2024-11-19T20:10:59.809967",
    //   createdAt: "2024-11-19T20:10:59.809967",
    //   displayName: "محمد",
    //   email: "",
    // },
  ]);

  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [refersh, setRefersh] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [commentIdToDelete, setCommentIdToDelete] = useState(null);
  const [editCommentId, setEditCommentId] = useState(null);

  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);

  const addComment = async () => {
    await RequestService.post(`Comment`, {
      projectId: projectId,
      message: text,
    })
      .then((response) => {
        if (response.status === 200) {
          toggleSnackbar();
          setText("");
          setRefersh(!refersh);
        }
      })
      .catch((errorResponse) => {
        toggleSnackbar2();
        console.log(errorResponse);
      });
  };

  const editComment = async () => {
    await RequestService.put(`Comment`, {
      id: editCommentId,
      message: text,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toggleSnackbar();
          setText("");
          setRefersh(!refersh);
        }
      })
      .catch((errorResponse) => {
        toggleSnackbar2();
        console.log(errorResponse);
      });
  };

  const handleConfirmDelete = async () => {
    if (commentIdToDelete) {
      try {
        await RequestService.delete(`Comment/${commentIdToDelete}`);
        toggleSnackbar();
        handleCloseDialog();
        setRefersh(!refersh);
        setTimeout(() => {
          setOpenDialog(false);
        }, 1000);
      } catch (error) {
        console.error("Error deleting project:", error);
        toggleSnackbar2();
        handleCloseDialog();
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await RequestService.get(`Comment/${projectId}`)
        .then(async (response) => {
          if (response.status === 200) {
            const data = response.data.data;
            let data2 = [];
            await data.map((item) => {
              item.displayName = item?.displayName || "بدون اسم";
              item.updatedAt = parseReadableDate(item.updatedAt);
              item.createdAt = parseReadableDate(item.createdAt);
              data2.push(item);
            });
            setComments(data2);
          }
        })
        .catch((errorResponse) => {
          console.log(errorResponse);
        });
    };
    fetchData();
  }, [refersh]);


  const handleOpenDialog = (id) => {
    setCommentIdToDelete(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCommentIdToDelete(null);
  };

  return (
    <Box>
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تم اتمام العملية"
        content="تم اتمام العملية بنجاح"
        dateTime="منذ 0 ثانية"
        open={show}
        close={toggleSnackbar}
      />
      <MDSnackbar
        color="error"
        icon="notifications"
        title="اضافة تعليق"
        content="حدث خطأ ما"
        dateTime="منذ 0 ثانية"
        open={error}
        close={toggleSnackbar2}
      />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-delete-dialog-title"
      >
        <DialogTitle id="confirm-delete-dialog-title">
          تأكيد الحذف
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* This action cannot be undone. Are you sure?
            <Divider sx={{ my: 1 }} /> */}
            سيتم حذف بيانات هذا بشكل نهائي. هل أنت متأكد؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleConfirmDelete} color="error">
            نعم
          </MDButton>
          <MDButton onClick={handleCloseDialog} color="secondary">
            لا
          </MDButton>
        </DialogActions>
      </Dialog>

      <Card sx={{ px: 4, py: 4, width: "100%", boxShadow: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
          التعليقات
        </Typography>
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {comments.map((comment, index) => (
            <React.Fragment key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: 140,
                '&:hover': {
                  boxShadow: 1,
                  transition: 'box-shadow 0.3s ease-in-out',
                },
              }}>
              <ListItem alignItems="flex-start" sx={{ py: 2 }}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: 'primary.main', width: 45, height: 45 }}>
                    {comment.displayName[0]}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography
                      component="span"
                      variant="subtitle1"
                      sx={{ fontWeight: 'bold', mb: 1 }}
                    >
                      {comment.displayName}
                    </Typography>
                  }
                  secondary={
                    <Box sx={{ mt: 1 }}>
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.secondary"
                        sx={{ display: 'block', mb: 0.5 }}
                      >
                        {comment?.email}
                      </Typography>
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.secondary"
                        sx={{ display: 'block', mb: 1, fontSize: '0.75rem' }}
                      >
                        {comment?.createdAt}
                      </Typography>
                      <Typography
                        component="span"
                        variant="body1"
                        color="text.primary"
                        sx={{ display: 'block' }}
                      >
                        {comment.message}
                      </Typography>
                    </Box>
                  }
                />
              </ListItem>

              <Grid container spacing={2} maxWidth={440}>
                <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <MDButton
                    variant="gradient"
                    color='error'
                    onClick={() => handleOpenDialog(comment.id)}
                    fullWidth
                    sx={{
                      py: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      maxWidth: 120,
                      gap: 1,
                      mx: 1,
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        transition: 'transform 0.2s ease-in-out',
                      },
                    }}
                  >

                    <Stack alignItems="center" spacing={0.5}>
                      <MDTypography variant="caption" color="white" fontWeight="regular" sx={{ display: 'flex', justifyContent: 'space-bettwen', alignItems: 'center', gap: 1 }}>
                        <Trash2 size={14} />
                        حذف
                      </MDTypography>
                    </Stack>
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color='info'
                    fullWidth
                    onClick={()=> {
                      setEditCommentId(comment.id)
                      setText(comment.message)
                      }}
                    sx={{
                      py: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      maxWidth: 100,
                      gap: 1,
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        transition: 'transform 0.2s ease-in-out',
                      },
                    }}
                  >

                    <Stack alignItems="center" spacing={0.5}>
                      <MDTypography variant="caption" color="white" fontWeight="regular" sx={{ display: 'flex', justifyContent: 'space-bettwen', alignItems: 'center', gap: 1 }}>
                        <Edit size={14} />
                        تعديل
                      </MDTypography>
                    </Stack>
                  </MDButton>
                </Grid>
              </Grid>
              {index < comments.length - 1 && (
                <Divider variant="inset" component="li" sx={{ my: 1 }} />
              )}
            </React.Fragment>
          ))}
        </List>
        <Box
          component="form"
          sx={{
            mt: 4,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
          onSubmit={(e) => {
            e.preventDefault();
            editCommentId != null ?
              editComment() :
              addComment();
          }}
        >
          <Paper
            elevation={0}
            sx={{
              p: 2,
              bgcolor: 'grey.50',
              borderRadius: 2,
            }}
          >
            <TextField
              label="اكتب تعليقك هنا..."
              variant="outlined"
              value={text}
              onChange={(e) => setText(e.target.value)}
              fullWidth
              multiline
              rows={3}
              sx={{
                '& .MuiOutlinedInput-root': {
                  bgcolor: 'background.paper',
                },
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
              <MDButton
                type="submit"
                variant="contained"
                color="info"
                endIcon={<SendIcon />}
                disabled={text.length == 0}
              >
              {editCommentId !== null ? 
                'تعديل التعليق' :
                'أضف تعليق'}
              </MDButton>
            </Box>
          </Paper>
        </Box>
      </Card>
    </Box>
  );
};
ProjectComments.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
export default ProjectComments;
